<script lang="ts">
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    function onCloseClick() {
        dispatch('close');
    }

</script>

<style lang="scss">

    @use '../variables';

    $small-height: 300px;
    $big-height: 400px;

    .map-popup {
        width: 100%;
        max-width: 300px;
        height: $small-height;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));
    }

    .map-popup-close-btn {
        position: absolute;
        z-index: 2;
        top: -1rem;
        right: -1rem;
        width: 2rem;
        height: 2rem;
        border: none;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--color-secondary);

        img {
            width: 1rem;
            height: 1rem;
        }
    }

    .map-popup-content {
        width: 100%;
        background-color: #fff;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
    }

    .slider-pointer {
        width: 32px;
        height: 32px;
        
        &::before {
            content: '';
            display: block;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 32px 16px 0 16px;
            border-color: #fff transparent transparent transparent;
        }

    }

    @media (min-height: variables.$big-phone-height) {
        .map-popup {
            max-width: 400px;
            height: $big-height;
        }
    }

</style>

<div class="map-popup disable-interactive">
    <button type="button" class="map-popup-close-btn enable-interactive" on:click={onCloseClick}>
        <img src="/images/times.svg" alt="">
    </button>

    <div class="map-popup-content enable-interactive">
        <slot></slot>
    </div>

    <div class="slider-pointer"></div>
</div>
